import React from 'react'
import { Box, Link } from '@maui/elements'
import { useExperiment } from '@maui-mf/root/experiments'

const sharedContainerStyles = {
  textDecoration: 'none',
  _hover: { textDecoration: 'none' },
  _focus: { textDecoration: 'none' },
  cursor: 'pointer',
}

const sharedButtonStyles = {
  height: '40px',
  width: '150px',
  fontSize: 'textBody1FontSize',
  textAlign: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  borderStyle: 'solid',
}

export const useLinkUrl = (urlParams) => {
  if (!urlParams) return null
  const encodedValue = encodeURIComponent(urlParams.value)
  return `/indicator/${urlParams.type}/${encodedValue}`
}

export const ToggleButton = ({ position, children, selected, ...restProps }) => {
  const borderWidthValue = selected ? '2px' : '1px'
  const borderRadius = position === 'left'
    ? { borderTopLeftRadius: '20px', borderBottomLeftRadius: '20px' }
    : { borderTopRightRadius: '20px', borderBottomRightRadius: '20px' }

  return (
    <Box
      {...restProps.href && { as: { Link } }}
      {...restProps}
      {...sharedContainerStyles}
      data-testid="toggle-button"
    >
      <Box
        backgroundColor={selected && '#8AB4F825'}
        color={selected ? 'colorActivePrimary' : 'colorTextMain'}
        borderColor={selected ? 'colorActivePrimary' : 'colorBorderMain'}
        // Padding increases 1px when border is only 1px
        p={selected ? '9px 12px 0 12px' : '9px 13px 0 13px'}
        borderWidth={borderWidthValue}
        {...sharedButtonStyles}
        {...borderRadius}
      >
        {children}
      </Box>
    </Box>
  )
}

export const ThreatScoreToggler = ({ urlParams }) => {
  const { enabled, granted, setExperiment } = useExperiment('mati_threat_indicators')
  // Make the toggler buttons links (used in indicator pages only)
  const asLink = !!urlParams
  const url = useLinkUrl(urlParams)

  const clickHandler = (bool) => {
    window?.gtag('event', 'click', {
      event_category: 'Threat Score - Track',
      event_label: `threat_score_toggle_button_${enabled ? 'opted-in' : 'opted-out'}`
    })
    setExperiment(bool)
  }

  if (!granted) {
    return null
  }

  return (
    <Box display="flex" gap="0" alignSelf="flex-end">
      <ToggleButton
        selected={!enabled}
        position="left"
        alt="Toggle to Threat Score view"
        onClick={() => clickHandler(false)}
        {...asLink &&
          {
            as: Link,
            href: url,
          }
        }
      >
        IC Score View
      </ToggleButton>
      <ToggleButton
        selected={enabled}
        position="right"
        alt="Toggle to Threat Score view"
        onClick={() => clickHandler(true)}
        {...asLink &&
          {
            as: Link,
            href: url,
          }
        }
      >
        Threat Score View
      </ToggleButton>
    </Box>
  )
}
